import Vue from 'vue'
import VueI18n from 'vue-i18n' // 国际化插件包
import locale from 'element-ui/lib/locale'
import elementEN from 'element-ui/lib/locale/lang/en' // 英文包
import customEN from '@/lang/en'
import AbbreviationEn from '@/lang/Abbreviation/en' // 缩写
import elementCN from 'element-ui/lib/locale/lang/zh-CN' // 中文
import customCN from '@/lang/zh-CN'
import AbbreviationCN from '@/lang/Abbreviation/zh-CN'
import elementTW from 'element-ui/lib/locale/lang/zh-TW' // 繁体
import customTW from '@/lang/zh-TW'
import AbbreviationTW from '@/lang/Abbreviation/zh-TW'

Vue.use(VueI18n) // 全局注册国际化包

// 创建国际化插件的实例
const i18n = new VueI18n({
  // 指定语言类型
  locale: 'zh_CN',
  // 将elementUI语言包加入到插件语言数据里
  messages: {
    // 英文环境下的语言数据
    en_US: {
      ...elementEN,
      ...customEN,
      ...AbbreviationEn
    },
    // 中文环境下的语言数据
    zh_CN: {
      ...elementCN,
      ...customCN,
      ...AbbreviationCN
    },
    // 繁体
    zh_TW: {
      ...elementTW,
      ...customTW,
      ...AbbreviationTW
    }
  }
})

// 配置elementUI 语言转换关系
locale.i18n((key, val) => i18n.t(key, val))

export default i18n
